import darken from "polished/lib/color/darken";
import styled from "../../../styled/index";
import { CS } from "../../../styles";
export const ItemListWrapper = styled("div") `
  width: 100%;
`;
export const ItemListContent = styled("div") `
  position: relative;
  width: 100%;
  border-radius: 3px;
  ${CS.shadow.med.one}
  > div {
    &:first-child {
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    &:last-child {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      border-bottom: none;
    } 
  }

  &[class*="v2"] {
      display: flex;
      gap: 16px;
      flex-direction: column;
      box-shadow: unset;

      &.grid {
        grid-template-columns: auto;
        @media (min-width: 768px) {
          grid-template-columns: repeat(2, minmax(0,1fr));
        }
        @media (min-width: 992px) {
          grid-template-columns: repeat(3, minmax(0,1fr));
        }
      }

      & div[class^="item-list"] {
        border-radius: 4px!important;
         > div {
          padding: 12px!important;

          & .m-b-1.big.font-semi-bold {
            font-size: 16px;
            line-height: 24px;
            margin: 0!important;
          }
        }
      }

      @media (max-width: 768px) {
        padding: 16px;
      }
  }
`;
export const ItemListItem = styled("div") `
  width: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
  transition: 0.26s all;
  background: white;
  border-bottom: 1px solid ${() => darken(0.1, "white")};
  &:hover {
    background: ${() => darken(0.02, "white")};
  }
`;
export const ItemListItemMobile = styled("div") `
  width: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
  transition: 0.26s all;
  background: white;
  border-bottom: 1px solid ${() => darken(0.1, "white")};
  &:hover {
    background: ${() => darken(0.02, "white")};
  }


  @media(min-width: 768px) {
    border-bottom: none
  }

`;
//# sourceMappingURL=index.js.map